import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Input } from '@angular/core';
import { Output, EventEmitter } from '@angular/core';
import { HelperService } from '../../../../services/helper/helper.service';
import { ControlBaseComponent } from '../control/control.component';

@Component({
  selector: 'app-control-textarea',
  styleUrls: ['./control-textarea.component.scss'],
  templateUrl: './control-textarea.component.html',
})
export class ControlTextAreaComponent extends ControlBaseComponent{

  @Input()  isDisabled: boolean;
  @Input()  isRequired: boolean;
  @Input()  placeholder: string;
  @Input()  label: string;
  @Input()  model: any;
  @Input()  bindValue: string;
  @Input()  cssClass: string;
  @Input()  controlName: any;
  @Input()  rows: number;
  @Output() ngModelChange = new EventEmitter();



  constructor(public helperService: HelperService,
              private changeDetection: ChangeDetectorRef) {
    super(helperService);
  }


  private SearchTimeout;

  private searchDelay = true;

  onKeyUp() {
    if (this.SearchTimeout) {
      clearTimeout(this.SearchTimeout);
      this.searchDelay = true;
    }
    if (this.searchDelay) {
      this.searchDelay = false;
      this.SearchTimeout = setTimeout(() => {
        this.ModelChange();
      }, 1500);
    }
    return
  }


  ModelChange() {
    if (this.ngModelChange) {
      this.ngModelChange.emit();
    }
  }
}
